<template>
  <div class="authentication">
    <input-page v-if="stage === 1" @next="next"/>
    <photo-page v-if="stage === 2" @submit="submit"/>
    <auth-dialog :show="showDialog" :success="submitSuccess" @confirm="goBack"/>
  </div>
</template>

<script>
import api from '@edu-fe/api'
import InputPage from '../components/Authentication/InputPage'
import PhotoPage from '../components/Authentication/PhotoPage'
import AuthDialog from '../components/Authentication/AuthDialog'

export default {
  name: 'Authentication',
  data () {
    return {
      stage: 1,
      showDialog: false,
      submitSuccess: true,
      submitData: {},
    }
  },
  components: {
    InputPage,
    PhotoPage,
    AuthDialog,
  },
  methods: {
    next (data) {
      Object.assign(this.submitData, data)
      this.stage = 2
    },
    goBack (state) {
      if (!!state) {
        this.$router.back(-1)
      } else {
        this.showDialog = false
      }
    },
    async submit (data) {
      Object.assign(this.submitData, data)
      const { code } = await api.authentication.verify(this.submitData)
      this.submitSuccess = code === 1
      this.showDialog = true
    }
  }
}
</script>
